import { render, staticRenderFns } from "./PRIVariant.vue?vue&type=template&id=4ad24703"
import script from "./PRIVariant.vue?vue&type=script&lang=js"
export * from "./PRIVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports